var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('p',{staticClass:"subtitle"},[_vm._v("You might also like these games")]),_vm._v(" "),_c('section',{staticClass:"card-deck"},_vm._l((_vm.posts.data),function(data,index){return _c('Card',{key:index,attrs:{"slug":data.slug,"image1":data.image1,"title":data.title}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da0b7890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomList.vue
// module id = null
// module chunks = 